import { render, staticRenderFns } from "./dig.vue?vue&type=template&id=04830c2c&"
import script from "./dig.vue?vue&type=script&lang=ts&"
export * from "./dig.vue?vue&type=script&lang=ts&"
import style0 from "./dig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports